module.exports = __webpack_public_path__ + "img/location.108b77a9.svg";